var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M6 18L18 6M6 6l12 12"}));
}

X.defaultProps = {"fill":"none","viewBox":"0 0 24 24","stroke":"currentColor"};

module.exports = X;

X.default = X;
